export default __webpack_public_path__ + "static/media/logo_rick_and_morty.54e125f0.png";